export enum InputBoxHeight {
  Md = 'medium',
  Lg = 'large',
}

export interface VerifiableInput {
  attribute: string;
  isVerified: boolean;
  verifyRouterLink?: string[];
}
